import { flexCollar as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Best Listings',
  queryParams: 'minPrice=1000000&maxPrice=3000000',
};

export default fakeProps(schema, TestData);
